// extracted by mini-css-extract-plugin
module.exports = {"base":"_2v4xwz","baseApp":"_2bbExT"};